export const QTC_FORM_ID = "edit-quote";

// Redux Actions
export const EXTERNAL_RESET = "qtc/EXTERNAL_RESET";
export const START_LOADING = "qtc/START_LOADING";
export const LOAD_ERROR = "qtc/LOAD_ERROR";
export const LOAD_SUCCESS = "qtc/LOAD_SUCCESS";
export const LOAD_REFERRALS = "qtc/LOAD_REFERRALS";
export const LOAD_QUOTE_SUCCESS = "qtc/LOAD_QUOTE_SUCCESS";
export const SEND_SAVE = "qtc/SEND_SAVE";
export const SEND_RATING_IMPACT = "qtc/SEND_RATING_IMPACT";
export const SAVE_SUCCESS = "qtc/SAVE_SUCCESS";
export const SAVE_ERROR = "qtc/SAVE_ERROR";
export const PAYMENT_ERROR = "qtc/PAYMENT_ERROR";
export const PAYMENT_SUCCESS = "qtc/PAYMENT_SUCCESS";
export const SET_MODAL_STATE = "qtc/SET_MODAL_STATE";
export const PUSH_CHANGE_HISTORY = "qtc/PUSH_CHANGE_HISTORY";
export const CLEAR_CHANGE_HISTORY = "qtc/CLEAR_CHANGE_HISTORY";
export const SET_EFFECTIVE_DATE = "qtc/SET_EFFECTIVE_DATE";
export const UPDATE_ACH_FORM = "qtc/UPDATE_ACH_FORM";
export const UPDATE_CC_FORM = "qtc/UPDATE_CC_FORM";
export const UPDATE_CHECK_FORM = "qtc/UPDATE_CHECK_FORM";
export const TOGGLE_SEARCH_MORTGAGEE_MODAL =
  "qtc/TOGGLE_SEARCH_MORTGAGEE_MODAL";
export const REX_UPDATE_VALUE_AND_RUN = "rex/UPDATE_VALUE_AND_RUN";
export const UPDATE_QUOTE_UTILITY_ACTIVE_TAB =
  "qtc/UPDATE_QUOTE_UTILITY_ACTIVE_TAB";

// QTC Steps (pages)
export const STEP_QUOTE = "quote";
export const STEP_SELECT = "select";
export const STEP_LOSS_HISTORY = "loss-history";
export const STEP_CHECKOUT = "checkout";
export type QuoteStep =
  | typeof STEP_QUOTE
  | typeof STEP_SELECT
  | typeof STEP_LOSS_HISTORY
  | typeof STEP_CHECKOUT;

export const COMMERCIAL_FUSIONS = [
  "address",
  "mortgageeSearch",
  "location",
  "location-count"
];
export const PL_FUSIONS = ["address", "mortgageeSearch"];
export const SAVE_DEBOUNCE_INITIAL = 5000;
export const SAVE_DEBOUNCE_LOW = 500;
export const SAVE_DEBOUNCE_HIGH = 2000;

// Eligibility Message Types
export const BLOCK = "BLOCK";
export const PREVENT = "PREVENT";
export const INFORM = "INFORM";
export const STOP = "STOP";
export const RATING_ERROR = "RATING_ERROR";

export const FETCH = {
  STATUS: {
    INITIAL: "INITIAL",
    BUSY: "BUSY",
    ERROR: "ERROR",
    DONE: "DONE"
  }
};

// These are terms (inputs) that are updated on the server (quotes-api)
// and need to be persisted in the form (passed into the model (rex))
// TODO find a better way to handle this situation
export const PERSISTED_TERMS = [
  "InsuranceScoreValid",
  "InsuranceScoreRetrieved",
  "InsuranceScoreStatusRetrieved",
  "InsuranceScoreReasonCode1",
  "InsuranceScoreReasonCode2",
  "InsuranceScoreReasonCode3",
  "InsuranceScoreReasonCode4",
  "InsuranceScore2Valid",
  "InsuranceScore2Retrieved",
  "InsuranceScore2StatusRetrieved",
  "InsuranceScore2ReasonCode1",
  "InsuranceScore2ReasonCode2",
  "InsuranceScore2ReasonCode3",
  "InsuranceScore2ReasonCode4",
  "PropertyId",
  // Trium Values
  "AAL",
  "AnalysisInProcess",
  "AnalysisValidated",
  "AnalysisID",
  "AnalysisURL",
  "ConstructionYearAnalyzed",
  "ConstructionYearRoofAnalyzed",
  "CoverageAAnalyzed",
  "CoverageBAnalyzed",
  "CoverageCAnalyzed",
  "CoverageDAnalyzed",
  "NumberOfStoriesAnalyzed",
  "RatingRequestID",
  "RiskID",
  "ScoringAnalysisID",
  "SquareFootUnderRoofAnalyzed",
  "TIVAnalyzed",
  "WorkflowId"
];
export const ELIGIBILITY_SUBTYPE = "quotingeligibility";
export const LOSS_SUBTYPE = "prebindreview";
export const SET_RCE_MODAL_DATA = "qtc/replacementCostModal/data/set";
export const QTC_TRACK = {
  QUOTE_FORM: {
    QUOTE_EDIT_VIEW: "Quote Form - Quote Edit Viewed",
    QUOTE_EDIT_PRODUCT_QUOTED: "Quote Form - Product Quoted",
    RUN_LOSS_HISTORY: "Quote Form - Run Loss History Clicked",
    FLOOD_PRO_CLICKED: "Quote Form - Flood Pro Button Clicked",
    REPLACEMENT_COST_CLICKED: "Quote Form - Replacement Cost Clicked",
    RCE_MODAL_DISPLAYED: "Quote Form - RCE Modal Displayed",
    SECTION_COMPLETED: "Quote Form - Section Completed",
    HELP_ICON_CLICKED: "Quote Form - Help Icon Clicked",
    EFFECTIVE_DATE_CHANGED: "Quote Form - Effective Date Changed",
    FORM_NAV_BUTTON_CLICKED: "Quote Form - Form Navigation Button Clicked",
    REMOVE_ADDRESS: "Edit Quote - Address Removed",
    LAUNCH_MAP_ID: "launchMap"
  },
  QUOTE_REFERRALS: {
    REFER_MODAL_DISPLAYED: "Quote Referrals - Refer Modal Displayed",
    REFER_PRODUCT_CLICKED: "Quote Referrals - Refer Product Clicked",
    REFER_PRODUCT_DISPLAYED: "Quote Referrals - Refer Product Displayed",
    MESSAGE_SUBMITTED: "Quote Referrals - Message Submitted",
    REFER_WITHDRAW_CLICKED: "Quote Referrals - Referral Withdraw Button Clicked"
  },
  QUOTE_SELECT: {
    PRODUCT_CARD_DISPLAYED: "Quote Select - Product Card Displayed",
    SELECT_SCREEN_VIEWED: "Quote Select - Select Screen Viewed",
    DEDUCTIBLE_TABLE_DISPLAYED: "Quote Select - Deductibles Table Displayed",
    VIEW_DEDUCTIBLE_OPTIONS_CLICKED:
      "Quote Select - View Deductible Options Clicked",
    DEDUCTIBLE_OPTIONS_DISPLAYED: "Quote Select - Deductible Options Displayed",
    NEW_DEDUCTIBLE_OPTION_SELECTED:
      "Quote Select - New Deductible Option Selected"
  },
  QUOTE_SIDEBAR: {
    COMPARE_CLICKED: "Quote Sidebar - Compare View Clicked",
    COMPARE_DISPLAYED: "Quote Sidebar - Compare View Displayed",
    PRODUCT_CARD_CLICKED: "Quote Sidebar - Product Card Clicked",
    MULTI_CARRIER_CARD_CLICKED: "Quote Sidebar - Multi-carrier Card Clicked",
    MESSAGE_LINK_CLICKED: "Quote Sidebar - Message Link Clicked",
    SIDEBAR_COLLAPSED: "Quote Sidebar - Sidebar Collapsed",
    SIDEBAR_EXPANDED: "Quote Sidebar - Sidebar Expanded"
  },
  QUOTE_CHECKOUT: {
    VIEWED: "Quote Checkout - Quote Checkout Viewed",
    BIND_CLICKED: "Quote Checkout - Bind Clicked",
    BIND_ERROR: "Quote Checkout - Bind Error Displayed",
    POLICY_BOUND: "Policy Bound - Bind succeeded",
    POST_BIND_MODAL_VIEWED: "Post Bind - Post Bind Modal Displayed"
  },
  QUOTE_NAVIGATION: {
    FIELD_SEARCHED: "Quote Navigation - Field Searched",
    STEP_CLICKED: "Quote Navigation - Next Step Clicked",
    NAVIGATION_CLICKED: "Quote Navigation - Navigation Clicked",
    SEARCHED_FIELD_CLICKED: "Quote Navigation - Searched Field Clicked",
    SECTION_CLICKED: "Quote Navigation - Section Clicked"
  },
  POST_BIND: {
    FLOOD_QUOTE_CLICKED: "Post Bind - Flood Quote Clicked"
  },
  QUOTE_COMPARE: {
    PAGE_VIEWED: "Compare: Page Viewed",
    SWITCH_PRODUCT: "Compare: Switch Products",
    NEW_QUOTE: "Compare: New Quote",
    EDIT_CURRENT_PRODUCT: "Compare: Edit Current Product",
    SELECT_PRODUCT: "Compare: Select"
  }
};

export const SAVE_QUEUE = {
  STATUS: {
    IDLE: "QUEUE_IDLE",
    PENDING: "QUEUE_PENDING",
    SUCCESS: "QUEUE_SUCCESS",
    REJECTED: "QUEUE_REJECTED"
  },
  ATTEMPTED: "QUEUE_SAVE_ATTEMPTED",
  RESET: "QUEUE_RESET"
};
